function p(t) {
  for (var c = t.constructor.prototype, o = 0, n = Object.getOwnPropertyNames(c); o < n.length; o++) {
    var r = n[o];
    if (r !== "constructor") {
      var e = Object.getOwnPropertyDescriptor(t.constructor.prototype, r);
      e && typeof e.value == "function" && (t[r] = t[r].bind(t));
    }
  }
  return t;
}
export {
  p as default
};
//# sourceMappingURL=index18.js.map
